import React from 'react'
import styled from 'styled-components';
import { Title } from '../../styles/shared';
import Accordion from '../elements/Accordion';
import { useRef } from 'react';
import { useLayoutEffect } from 'react';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";


const Section = styled.section`
padding:1.7rem 0;
min-height: 100vh;
min-height: 100svh;
width: 100vw;
background-color: ${props => props.theme.text};
position: relative;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
color: ${props => props.theme.body};
padding: 1rem 0 3rem 0;
`;

const Container = styled.div`
width: 75%;
margin: 2rem auto;

display: flex;
justify-content: space-between;
align-content:center;
flex-wrap: wrap;

@media (max-width: 74em){
   width: 80%;
}
@media (max-width: 64em){
   width: 90%;
   flex-direction: column;
   &>*:last-child{
    &>*:first-child{
      margin-top: 0;
    }
   }
}
`;

const Box = styled.div`
  width: 45%;
  @media (max-width: 64em){
   width: 90%;
   align-self: center;
}
`;

function FAQ() {
  const ref = useRef(null);
  gsap.registerPlugin(ScrollTrigger);
  useLayoutEffect(() => {
    let element = ref.current;
    ScrollTrigger.create({
      trigger: element,
      start: "top top",
      end: "bottom top",
      pin: true,
      pinSpacing: false,
      scrub: true
    })
    return () => {
      ScrollTrigger.killAll();
    };
  }, []);
  return (
    <Section ref={ref} id="faq">
      <Title mode="dark">
        FAQ
      </Title>
      <Container>
        {/* left side */}
        <Box>
  <Accordion title="WHAT IS AIREDIFY?">
    AirEdify is an innovative online platform designed to empower learners by providing personalized learning pathways, curated resources, and opportunities for collaboration within various fields of study.
  </Accordion>
  <Accordion title="HOW DO I CREATE AN ACCOUNT ON AIREDIFY?">
    You can create an account by visiting our website and clicking on the "Sign Up" button. Follow the prompts to enter your information, and verify your email to activate your account.
  </Accordion>
  <Accordion title="WHAT TYPES OF RESOURCES ARE AVAILABLE ON AIREDIFY?">
    AirEdify offers a wide range of resources, including tutorials, video content, notes, and access to certified masterclasses tailored to your chosen learning pathways.
  </Accordion>
  <Accordion title="HOW DOES THE PERSONALIZED LEARNING ROADMAP WORK?">
    After selecting your interests, AirEdify generates a personalized learning roadmap that outlines the structured tutorials, videos, and resources you'll need to enhance your skills and knowledge in your selected topics.
  </Accordion>
</Box>

{/* right side */}
<Box>
  <Accordion title="CAN I CONNECT WITH OTHER LEARNERS ON AIREDIFY?">
    Yes! AirEdify allows you to join interest-based communities where you can connect, collaborate, and share experiences with other learners who share your interests and career goals.
  </Accordion>
  <Accordion title="HOW CAN I STAY INFORMED ABOUT UPCOMING EVENTS AND MASTERCLASSES?">
    AirEdify notifies users about upcoming events, masterclasses, and extracurricular activities through your account dashboard and email notifications.
  </Accordion>
  <Accordion title="CAN I PARTICIPATE IN COMPETITIONS AND HACKATHONS THROUGH AIREDIFY?">
    Yes, you can browse and apply for various competitions, hackathons, and industry events directly from the platform, allowing you to put your skills into action.
  </Accordion>
  <Accordion title="HOW CAN I CONTACT AIREDIFY SUPPORT FOR ASSISTANCE?">
    For any inquiries or support needs, you can reach out to our customer service team through the "Contact Us" section on our website or by emailing support@airedify.com.
  </Accordion>
</Box>



      </Container>
    </Section>
  )
}
export default FAQ;